import {
  isEmpty,
  toBoolean,
  toDecimal,
  toInteger,
} from "../gui_components/Util.js";

export class ConfigManager {
  constructor() {
    let lsCompConfigs = JSON.parse(localStorage.getItem("companyConfig"));
    let lsConfigs = JSON.parse(localStorage.getItem("configs"));

    this.compConfigs = [];
    this.configs = [];
    if (lsCompConfigs != null) {
      lsCompConfigs.map((line) => {
        this.compConfigs[line.code] = line;
      });
    }
    if (lsConfigs != null) {
      lsConfigs.map((line) => {
        this.configs[line.code] = line;
      });
    }
  }
  static compConfigs = [];
  static configs = [];
  static initConfigs() {
    let lsCompConfigs = JSON.parse(localStorage.getItem("companyConfig"));
    let lsConfigs = JSON.parse(localStorage.getItem("configs"));
    if (lsCompConfigs != null) {
      lsCompConfigs.map((line) => {
        this.compConfigs[line.code] = line;
      });
    }
    if (lsConfigs != null) {
      lsConfigs.map((line) => {
        this.configs[line.code] = line;
      });
    }
  }
  static PRODUCT_HIEREARCHY_LEVEL_KEY = "product_hierarchy_level";
  static ITEM_LEVEL_KEY = "item_level";
  static RAW_MATERIAL_PRODUCT_HIERARCHY_LEVEL_KEY =
    "raw_material_product_hierarchy_level";
  static RAW_MATERIAL_LEVEL_KEY = "raw_material_level";
  static CUSTOMER_HIERARCHY_LEVEL_KEY = "customer_hierarchy_level";
  static CUSTOMER_GEOGRAPHICAL_HIERARCHY_LEVEL_KEY =
    "customer_geographical_hierarchy_level";
  static ENTERPRICE_INFO_MAIL_CONTACT_PERSON_KEY =
    "enterprise_info_mail_contact_person";
  static ENTERPRICE_INFO_MAIL_TO_KEY = "enterprise_info_mail_to";
  static ENTERPRICE_INFO_MAIL_CC_KEY = "enterprise_info_mail_cc";
  static ENTERPRICE_INFO_MAIL_FROM_KEY = "enterprise_mail_from";
  // For Mail Message
  static ENTERPRICE_PURCHASE_MAIL_CONTACT_PERSON_KEY =
    "enterprise_purchase_mail_contact_person";
  static ENTERPRICE_PURCHASE_MAIL_TO_KEY = "enterprise_purchase_mail_to";
  static ENTERPRICE_PURCHASE_MAIL_CC_KEY = "enterprise_purchase_mail_cc";
  static ENTERPRICE_SALES_MAIL_CC_KEY = "enterprise_sales_mail_cc";
  static ENTERPRICE_SALES_MAIL_TO_KEY = "enterprise_sales_mail_to";
  static CURRENCY_CODE_KEY = "currency_code";
  static DEFAULT_CRITICAL_PATH_MANAGEMENT_TEMPLATE_KEY =
    "default_criticalpathmanagement_template";
  static SALES_TAX_PERCENTAGE_KEY = "sales_tax_percentage";
  static WHOLE_SALE_MARKUP_PERCENTAGE_KEY = "whole_sale_markup_percentage";
  static RETAIL_SALE_MARKUP_PERCENTAGE_KEY = "retail_markup_percentage";
  static FINISHED_GOODS_WAREHOUSE_CODE_KEY = "finished_goods_warehouse_code";
  static FINISHED_GOODS_BADQUALITY_WAREHOUSE_CODE_KEY =
    "finished_goods_badQuality_warehouse_code";
  static FINISHED_GOODS_INVENTORY_UOM_CODE_KEY =
    "finished_goods_inventory_uom_code";
  static RAW_MATERIAL_WAREHOUSE_CODE_KEY = "raw_material_warehouse_code";
  static SALES_PRICE_FETCH_LOGIC_ORDER_KEY = "sales_price_fetch_logic_order";
  static PURCHASE_COST_FETCH_LOGIC_ORDER_KEY =
    "purchase_cost_fetch_logic_order";
  static SMTP_HOST_KEY = "smtp_host";
  static SMTP_AUTHENTICATION_REQUIRED_KEY = "smtp_authentication_required";
  static SMTP_USER_NAME_KEY = "smtp_user_name";
  static SMTP_PASSWORD_KEY = "smtp_password";
  static SMTP_SSL_REQUIRED_KEY = "smtp_ssl_required";
  static SCREEN_MODE_KEY = "screen_mode";
  static COOLER_LOCATION_CODE_KEY = "cooler_location";
  static HOLDER_LOCATION_CODE_KEY = "holder_location";
  static SPECIAL_MESSAGE_FOR_INVOICE_PRINTOUT =
    "special_message_for_invoice_printout";
  static EXCLUDED_FABRIC_CODE_KEY = "excluded_fabrics_all_ats_report";
  static FABRIC_COLOR_CODE_VERSION_KEY =
    "farbicstylecolor_version_number_required";
  static FABRIC_STYLE_DEFAULT_WIDTH_UOM_CODE_KEY =
    "fabric_style_default_width_uom";
  static FABRIC_STYLE_DEFAULT_WEIGHT_UOM_CODE_KEY =
    "fabric_style_default_weight_uom";
  static FABRIC_STYLE_DEFAULT_DIVISION_CODE_KEY =
    "fabric_style_default_division";
  static ISMANUAL_INCOTERM_ENTRY_KEY = "ismanual_inco_term_entry";
  static ISMANUAL_FOB_CITY_ENTRY_KEY = "ismanual_fob_city_entry";
  static SALESORDER_VALIDATE__SAME_CUSTOMER_AND_PO_NUMBER_KEY =
    "so_validate_same_customer_po";
  static SHOW_CUSTOMER_RESERVE_INVENTORY_KEY =
    "show_customer_reserve_inventory";
  static IS_SALES_LINE_TAX_MODIFY_FLAG_KEY = "sales_line_tax_modify_flag";
  static SAMPLE_ITEM_SPECIAL_PROCESS_REQUIRED_KEY =
    "sample_item_special_process_required";
  static USE_MANUAL_PICKTICKET_NUMBER_FLAG_KEY =
    "use_manual_pickticket_number_flag";
  static USE_INTRANSIT_INV_FOR_PURCHASE_INTRANSIT_IN_ATS_KEY =
    "use_inTransit_inv_in_ATS_flag";
  static UPLOAD_IMAGE_MAX_SIZE_IN_MB_KEY = "upload_image_max_size_in_mb";
  static UPLOAD_DOCUMENT_MAX_SIZE_IN_MB_KEY = "upload_document_max_size_in_mb";
  static SALES_Tariff_PERCENTAGE_KEY = "sales_tariff_percentage";
  static EXCLUDE_RESERVE_INVENTORY_LOCATION_IN_ATS_KEY =
    "exclude_reserve_inventory_in_ats";
  static ALLOW_DUPLICATE_SALE_ORDER_ORDER_LINES_KEY =
    "allow_duplicate_sale_order_line_flag";
  static USE_DEFAULT_WAREHOUSE_DETAIL_DORELL = "use_default_bin_loc_warehouse";
  static SALES_ORDER_LINES_VALIDATION_KEY = "sales_lines_validation_req";
  static ACCOUNT_RECEIVABLE_TAX_PERCENTAGE_KEY = "ar_tax_percentage";
  static LOAD_SALES_ORDER_CSR_FROM_CUSTOMER = "load_so_csr_from_customer";
  static USE_ADVANCED_PICK_TICKET_LINE = "use_adv_pick_ticket_line";
  static SHOW_VENDOR_FACTORY_NODE = "show_vendor_factory_node";
  static SHOW_BIN_LOCATION_LOOKUP = "show_bin_location_lookup";
  static FABRIC_TARIFF_PERCENTAGE_KEY = "fabric_tariff_percentage";
  static INCLUDE_HEARDER_TARIFF_PERCENTAGE_KEY =
    "is_include_header_tariff_percentage";
  static PURCHASE_BASED_CUSTOMER_KEY = "purchase_based_customer_flag";
  static MODULE_VERSION_BASED_ON_COMPANY = "module_version_based_on_company";
  /* version_1 -> RAMTEX,3PL
  version_2 -> DORELL
  version_3 -> REX_Fabrics
  version_4 -> for future */
  static PWD_REQ_SALES_COMM_MODULE = "is_pwd_req_sales_comm_module";
  static PWD_SALES_COMM_MODULE = "pwd_sales_comm_module";
  static UPLOAD_IMAGE_MAX_SIZE_IN_MB = "upload_image_max_size_in_mb";
  static PURCHASE_ORDER_TYPE_VALIDATION_REQUIRED_KEY = "use_po_validation_flag";
  static SHOW_DASHBOARD_BASED_ON_COMPANY = "show_dashboard_based_on_company";
  static SPECIAL_PRICE_CALCULATION_REQUIRED =
    "special_price_calculation_required";
  static DEFAULT_ITEM_COLOR_CODE = "default_item_color_code";
  static ATS_LOADED_WITHOUT_VALIDATION = "is_ats_loaded_without_validation";
  static ATS_PAGE_SIZE = "ats_page_size";
  static SALES_ORDER_LINE_ONHAND_VALIDATON_REQUIRED =
    "sales_order_onhand_validation_required";

  static EXCLUDE_LOCATION_CODE_FOR_ATS = "exclude_location_code_for_ats";
  
  static IS_TEXO_FABRIC_KEY = "texco_fabrics_flag";

  static  CPM_TEMPALTE_DEFAULT_KEY = "cpm_template_default_code"; 

  static DEFAULT_UOM_CODE_KEY = "default_uom_code";//configManager

  static VENDOR_INVOICE_TYPE_CODE_KEY = "vendor_invoice_type";

  static SALES_ZERO_PRICE_VALIDATON_REQUIRED ="sales_zero_price_validation_required";  

  static DEFAULT_TEXCO_WAREHOUSE = "use_default_texco_warehouse";

  static DEBIT_MEMO_TYPE_CODE_KEY = "debit_memo_type";
  
  static DEFAULT_WAREHOUSE_TEXCO  ="default_wareHouse_texco";  
  static SUPPRESS_SALES_ORDER_COST_PRICE_VALIDATION = "supress_salesorder_cost_price_validation";


   
  static getCurrencyCode() {
    let value = this.getValue(this.CURRENCY_CODE_KEY);
    return value;
  }
  static getFinishedGoodsWareHouse() {
    let value = this.getValue(this.FINISHED_GOODS_WAREHOUSE_CODE_KEY);
    return value;
  }
  static getIsUseDefaultBinLocationOfTheWarehouse() {
    let value = false;
    value = toBoolean(this.getValue(this.USE_DEFAULT_WAREHOUSE_DETAIL_DORELL));
    return value;
  }
  static getSalesTaxPercentage() {
    let value = this.getValue(this.SALES_TAX_PERCENTAGE_KEY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static excludeReserveInventoryInATSFlag() {
    let value = this.getValue(
      this.EXCLUDE_RESERVE_INVENTORY_LOCATION_IN_ATS_KEY
    );
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static isPurchaseBasedOnCustomerFlag() {
    let value = this.getValue(this.PURCHASE_BASED_CUSTOMER_KEY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static getModuleVersion() {
    let value = this.getValue(this.MODULE_VERSION_BASED_ON_COMPANY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static isPasswordRequiredForSalesCommission() {
    let value = this.getValue(this.PWD_REQ_SALES_COMM_MODULE);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static getPasswodForSalesCommission() {
    let value = this.getValue(this.PWD_SALES_COMM_MODULE);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static getUploadImageMaxSizeInMB() {
    let value = this.getValue(this.UPLOAD_IMAGE_MAX_SIZE_IN_MB);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static isShowBinLocationLookup() {
    let value = this.getValue(this.SHOW_BIN_LOCATION_LOOKUP);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static purchaseOrderTypeValidationRequired() {
    let value = this.getValue(this.PURCHASE_ORDER_TYPE_VALIDATION_REQUIRED_KEY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static isShowDashBoard() {
    let value = this.getValue(this.SHOW_DASHBOARD_BASED_ON_COMPANY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static isSpecialPriceCalculated() {
    let value = this.getValue(this.SPECIAL_PRICE_CALCULATION_REQUIRED);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static getDefaultItemColorCode() {
    let value = this.getValue(this.DEFAULT_ITEM_COLOR_CODE);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  static isAtsLoadedWithOutValidation() {
    let value = this.getValue(this.ATS_LOADED_WITHOUT_VALIDATION);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static isSalesOrderOnHandQuantityValidationRequried() {
    let value = this.getValue(this.SALES_ORDER_LINE_ONHAND_VALIDATON_REQUIRED);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static getAtsPageSize() {
    let value = this.getValue(this.ATS_PAGE_SIZE);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static getExcludeLocationCode() {
    let value = this.getValue(this.EXCLUDE_LOCATION_CODE_FOR_ATS);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static getLockType(_value) {
    const value = this.getValue(_value);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }
  

  static isTexcoFabricKey() {
    let value = this.getValue(this.IS_TEXO_FABRIC_KEY);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }   

  static getUomCode() {
    let value = this.getValue(this.DEFAULT_UOM_CODE_KEY);
    return value;
  }

  static isCpmDefaultTemplateCode() {
    let value = this.getValue(this.CPM_TEMPALTE_DEFAULT_KEY );
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }   

  static getVendorInvoiceType() {
    let value = this.getValue(this.VENDOR_INVOICE_TYPE_CODE_KEY);

    return value;
  }  

  static isSalesZeroPriceValidationRequried() {
    let value = this.getValue(this.SALES_ZERO_PRICE_VALIDATON_REQUIRED);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static getDebitMemoType() {
    let value = this.getValue(this.DEBIT_MEMO_TYPE_CODE_KEY);
  if (isEmpty(value)) {
      return null;
    }
    return value;
  }    
  
  static isDefaultWarehouse() {
    let value = this.getValue(this.DEFAULT_TEXCO_WAREHOUSE);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }

  static isSupressSalesOrderCostPriceValidation() {
    let value = this.getValue(this.SUPPRESS_SALES_ORDER_COST_PRICE_VALIDATION);
    console.log("isSupressSalesOrderCostPriceValidation value:", value);
    if (isEmpty(value)) {
      return null;
    }
    return value;
  }  

  static getValue(key) {
    let value = "";
    if (this.compConfigs != null) {
      let compConfigBean = this.compConfigs[key];
      if (compConfigBean != null && compConfigBean != undefined) {
        value = compConfigBean.value;
      }
    }
    if (this.configs != null) {
      let configBean = this.configs[key];
      if (configBean !== null && configBean != undefined) {
        if (configBean.type == "S") {
          return configBean.value;
        } else if (configBean.type == "B") {
          return toBoolean(configBean.value);
        } else if (configBean.type == "I") {
          return toInteger(configBean.value);
        } else if (configBean.type == "D") {
          return toDecimal(configBean.value);
        } else if (configBean.type == "P") {
          return toDecimal(configBean.value);
        }
        value = configBean.value;
        //ToDoNeed Check With Type for Return Number or String Values
      }
    }
    return value;
  }
}
